import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import Button from '@components/ui/Button';
import SEO from '@components/ui/SEO';
import { errorFallback, finishRegistration, forbidden, unlockWallet } from '@intl/generic';

export type ForbiddenReason = 'wallet-locked' | 'unregistered' | undefined;

const ForbiddenPage = ({ reason }: { reason: ForbiddenReason }) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const renderError = () => {
    switch (reason) {
      case 'wallet-locked':
        return (
          <FormattedMessage
            id="error.403.lockedWalletDescription"
            defaultMessage="Whoops! Please unlock your wallet to view this page."
            description="Error description"
          />
        );
      case 'unregistered':
        return (
          <FormattedMessage
            id="error.403.finishRegistrationDescription"
            defaultMessage="Whoops! Please finish registration to view this page."
            description="Error description"
          />
        );
      default:
        return <FormattedMessage {...errorFallback} />;
    }
  };

  const renderActionButton = () => {
    switch (reason) {
      case 'wallet-locked':
        return (
          <Button onClick={() => navigate('/dashboard')}>
            <FormattedMessage {...unlockWallet} />
          </Button>
        );
      case 'unregistered':
        return (
          <Button onClick={() => navigate('/register')}>
            <FormattedMessage {...finishRegistration} />
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex justify-center items-center h-full">
      <SEO pageTitle="403" pageDescription={`403 - ${formatMessage(forbidden)}`} />

      <div className="text-center space-y-4">
        <h1>
          403 - <FormattedMessage {...forbidden} />
        </h1>
        <p className="mb-4">{renderError()}</p>

        {renderActionButton()}
      </div>
    </div>
  );
};

export default ForbiddenPage;
